import { render, staticRenderFns } from "./alert-message.vue?vue&type=template&id=2a2dd1de&scoped=true&lang=pug&"
import script from "./alert-message.vue?vue&type=script&lang=js&"
export * from "./alert-message.vue?vue&type=script&lang=js&"
import style0 from "./alert-message.vue?vue&type=style&index=0&id=2a2dd1de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2dd1de",
  null
  
)

export default component.exports